module.exports = __webpack_public_path__ + "img/teherbiras.fba3ba7f.svg";